function Docs({ className = 'h-6 w-6' }) {
  return (
    <svg
      className={className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.26767 0C2.66517 0 2.17676 0.488417 2.17676 1.09091V14.9091C2.17676 15.5116 2.66517 16 3.26767 16H12.7222C13.3247 16 13.8131 15.5116 13.8131 14.9091V4.36364L9.44949 0H3.26767Z'
        fill='#4582F4'
      />
      <path
        d='M9.44824 0L13.8119 4.36364H9.44827C9.44827 4.40359 9.44827 4.40359 9.44827 4.36364L9.44824 0Z'
        fill='#1E64D2'
      />
      <path
        d='M10.7222 7.45459H4.17676V8.32732H10.7222V7.45459Z'
        fill='white'
      />
      <path
        d='M4.17676 9.20004H10.7222V10.0728H4.17676V9.20004Z'
        fill='white'
      />
      <path
        d='M9.08585 10.9455H4.17676V11.8182H9.08585V10.9455Z'
        fill='white'
      />
    </svg>
  )
}
export default Docs
